import {
  hexToRgb,
  interpolateColors
} from 'application/src/js/functions.js';

/**
 * Statistics: Clicks per date chart
 * @param {DataStore} store - storage
 * @param {object} baseColors - colour palette
 */
class ClicksHistoryChart {
  constructor(args) {
    this.store = args.store;
    this.baseColors = args.baseColors;
    this.outerContainer = document.querySelector('.clicks-chart');
    this.chartCanvas = this.outerContainer.querySelector('canvas');
    this.chartTypeSelection = this.outerContainer.querySelector('.chart-type-selection')
    this.graphType = 'bar';
    this.chartData = [];
    this.colors = []; // rgb colors interpolated between the baseColors

    this.initGraph();
    this.addEvents();
  }

  addEvents() {
    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, state => {
        this.data = Object.assign({}, state.chart);

        if (eventType == 'init') {
          this.colors = interpolateColors(
            ...this.baseColors.map(hex => `rgb(${hexToRgb(hex).join(',')})`),
            Object.keys(this.data).length
          ).map(rgb => `rgb(${rgb.join(',')})`);
        }

        this.chartData = Object.values(this.data).reduce((chartData, productData) => {
          chartData[productData.global_product_basic_id] = {
            chartData: productData.clicks.reduce((productChartData, click) => {
              productChartData.push({
                x: click.date,
                y: click.amount
              });
              return productChartData;
            }, []),
            id: productData.global_product_basic_id,
            productName: state.products[productData.global_product_basic_id]
          }

          return chartData;
        }, {});

        this.updateGraph();
      });
    });
  }

  initGraph() {
    let chartSettings = {
      type: this.graphType,
      data: {
        datasets: this.datasets,
      },
      options: {
        bezierCurve: false,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: this.datasets.length > 1
          },
          tooltip: {
            callbacks: {
              title: context => moment(context[0].raw.x).format('L')
            }
          }
        },
        scales: {
          x: {
            grid: {
              drawBorder: false,
              display: false,
            },
            type: 'time',
            time: {
              unit: 'day',
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 20
            }
          },
          y: {
            grid: {
              drawBorder: false,
              display: false
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 20
            }
          },
        },
        responsive: true,
        elements: {
          line: {
            tension: 0,
            borderWidth: 2
          },
          point: {
            radius: 3,
            hitRadius: 3,
            hoverRadius: 3,
          }
        }
      }
    };

    this.chart = new Chart(this.chartCanvas, chartSettings);
  }

  get datasets() {
    return Object.keys(this.chartData).reduce((data, id, i) => {
      data.push({
        data: this.chartData[id].chartData,
        borderColor: this.colors[i],
        pointBackgroundColor: this.colors[i],
        pointBorderColor: this.colors[i],
        label: `${this.chartData[id].productName}`,
        backgroundColor: this.graphType == 'bar' ? this.colors[i] : 'transparent',
      });

      return data;
    }, []);
  }

  updateGraph() {
    const datasets = this.datasets;

    this.chart.data.datasets = datasets;
    this.chart.options.plugins.legend.display = datasets.length > 1;

    const numClicks = Math.max(...Object.keys(this.chartData).reduce((clicks, productId) => {
      clicks.push(this.chartData[productId].chartData.length);
      return clicks;
    }, []));

    this.chart.update();
  }
}

export default ClicksHistoryChart;